import React, { useState } from "react";

const Ask = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const questions = [
    {
      q: "إزاي أقدر أحجز استشارة قانونية؟",
      a: "تقدر تحجز استشارتك بسهولة من خلال الاتصال برقم المكتب : 01110251645 | 01027050624",
    },
    {
      q: "هل المكتب بيقدم استشارات أونلاين؟",
      a: "نعم, بنوفر استشارات قانونية عبر مكالمات الفيديو أو الواتساب لتوفير وقت وجهد عملائنا في أي مكان داخل مصر أو خارجها.",
    },
    {
      q: "إيه المجالات القانونية اللي بيتخصص فيها المكتب؟",
      a: " المكتب متخصص في القضايا المدنية، القضايا الجنائية , التجارية، الأحوال الشخصية، قضايا الشركات، والتعويضات.",
    },
    {
      q: "هل المكتب بيتولى قضايا الشركات وتأسيسها؟",
      a: "نعم، بنقدم خدمات تأسيس الشركات، وصياغة العقود، ومتابعة الإجراءات القانونية بالكامل أمام الجهات المختصة.",
    },
    {
      q: "هل أقدر أستعين بالمكتب في قضايا الأسرة والطلاق؟",
      a: "بالتأكيد، المكتب بيتولى قضايا الأحوال الشخصية بجميع أنواعها: نفقة، طلاق، حضانة، وتمكين , اثبات نسب , اثبات زواج.",
    },
    {
      q: "هل المكتب بيتعامل مع العملاء من خارج مصر؟",
      a: "نعم، بنستقبل القضايا والاستشارات من عملاء مصريين بالخارج عن طريق التواصل الإلكتروني والدفع الآمن أونلاين.",
    },
    {
      q: "إزاي أقدر أعرف تكلفة الاستشارة أو القضية؟",
      a: "التكلفة بتتحدد حسب نوع القضية أو الاستشارة، وبعد عرض التفاصيل بيتم تحديد السعر بكل شفافية قبل البدء في أي إجراء.",
    },
    {
      q: "هل المكتب بيتابع القضايا حتى صدور الحكم؟",
      a: "طبعًا، المكتب بيتولى القضية من البداية للنهاية، مع تحديث العميل أولًا بأول بكل خطوة في سير الدعوى.",
    },
    {
      q: "هل المكتب بيقدم خدمات التوكيلات أو العقود؟",
      a: "نعم، بنساعد في إعداد وصياغة وتوثيق جميع أنواع العقود والتوكيلات بطريقة قانونية سليمة تضمن حقوق العميل.",
    },
    {
      q: "إيه مواعيد عمل المكتب؟",
      a: "المكتب بيستقبل العملاء من السبت إلى الاربعاء، من الساعة 7 مساءً حتى 11 مساءً، ويمكن حجز موعد مسبق لتأكيد الحضور.",
    },
  ];

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="ask">
      <div className="mainTitle">
        <div className="lines">
          <div className="line"></div>
          <div className="line"></div>
          <div className="title">
            <h2>الأسئلة الشائعة</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mainContent">
          <div className="boxs">
            {questions.map((item, index) => (
              <div
                className={`box ${activeIndex === index ? "active" : ""}`}
                key={index}
                onClick={() => toggle(index)}
              >
                <div className="qut">
                  <h3>{item.q}</h3>
                  <span>{activeIndex === index ? "−" : "+"}</span>
                </div>
                <div className="answer">
                  <p>{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ask;
